import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setSubscriber ,setErrorPage , reportDWH} from '../../EnergyReplaceBlockSlice';
import { filterPackagesAsync } from '../../EnergyReplaceBlockAsyncThunk';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Subscribers from '../../../../Shared/GeneralPages/Subscribers/Subscribers';

const SubscriberPage = (props) => {

    const options = {
        title: `היי ${props.firstName}, זיהינו אצלך <br/> מספר מנויי ${window.Config.brand_Name_HE} Energy`,
        subTitle: 'באיזה מנוי לבצע את הפעולה?',
        buttonText: 'לשינוי התוכנית'
    }

    useEffect(() => {

    }, []);

    return (
        <div className='subscribers-page'>
            <Subscribers options={options} saleType={'energy'} onSelectSubscriber={handleOnSelectSubscriber} />
        </div>
    );

    function handleOnSelectSubscriber(subscriber) {

        if (subscriber) {
            props.setSubscriber(subscriber);
            props.reportDWH({
              actionType: 'SelectSubscriberForPlanChange',
              status: 'Ongoing',
              messageText: 'SubscriberSelectionDisplay'
            });

            if (subscriber.accountType != 'I' && subscriber.accountType != 'S') {
                props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });

                props.setErrorPage('ACCOUNT_TYPE_ERROR');
                return;
            }

            if (!subscriber.isJetService) {
                props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });
                props.setErrorPage('NOT_JET_CUSTOMER_ERROR');
                return;
            }

            if (subscriber.isTaoz) {
                props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });
                props.setErrorPage('TAOZ_ERROR');
                return;
            }

            if (subscriber.futurePP) {
                props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });
                props.setErrorPage('FUTURE_PRICE_PLAN_ERROR');
                return;
            }

            if (subscriber.hasOpenOrder) {
                props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });
                props.setErrorPage('GENERAL_ERROR');
                return;
            }

            if (subscriber.isEnergyBundle) {
                 props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });
                props.setErrorPage('ENERGY_BUNDLE_ERROR');
                return;
            }

            if (subscriber.hasDebt || subscriber.hasPaymentMethodIssue) {
                if (subscriber.hasDebt && subscriber.hasPaymentMethodIssue) {
                props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });
                    props.setErrorPage('PAYMENT_AND_DEBT_ERROR');
                }
                else {
                props.reportDWH({
                  actionType: 'SubscriberSelectionFailed',
                  status: 'Error',
                  messageText: 'SubscriberSelectionFailureDisplay'
                });
                    props.setErrorPage(subscriber.hasDebt ? 'DEBT_ERROR' : 'PAYMENT_ERROR');
                }
            }
            else {
                props.filterPackagesAsync();
            }
        }
        else {
          props.reportDWH({
            actionType: 'SubscriberSelectionFailed',
            status: 'Error',
            messageText: 'SubscriberSelectionFailureDisplay'
          })
          props.setErrorPage('NO_SUBSCRIBER_ERROR');
        }
    }

};

const mapStateToProps = (state) => {
    return {
        page: state.energyReplaceBlock.page,
        firstName: state.authentication?.loginData?.userDetails?.firstName
    };
};

const mapDispatchToProps = {
    filterPackagesAsync,
    setSubscriber,
    setErrorPage,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberPage);
